import React from 'react';
import './App.css';
import Portfolio from './components/Portfolio';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <h1>Моё портфолио</h1>
      </header>
      <Portfolio />
    </div>
  );
}

export default App;
